import styled from 'styled-components';
import Chip from '../../atoms/Chip';
export const variantionsSize = {
  xsmall: {
    size: 'xsmall',
    width: '15px',
    height: '15px',
    minWidth: '152px',
    maxWidth: '152px',
    fontSize: 0
  },
  small: {
    size: 'small',
    width: '17px',
    height: '17px',
    minWidth: '153px',
    maxWidth: '153px',
    fontSize: 1
  },
  medium: {
    size: 'medium',
    width: '20px',
    height: '18px',
    minWidth: '160px',
    maxWidth: '160px',
    fontSize: 1
  }
};
export const Container = styled(Chip).attrs(({
  variant,
  startIcon
}) => ({
  bg: 'magabluLight',
  fontSize: 0,
  startIcon,
  fontWeight: 'medium',
  gridGap: 1,
  borderRadius: 8,
  mb: 2,
  mt: 2,
  color: 'primary',
  justify: 'start',
  padding: '2px 8px',
  minWidth: variantionsSize[variant].minWidth,
  maxWidth: variantionsSize[variant].maxWidth,
  textMaxWidth: 'auto',
  size: variantionsSize[variant].size
}))``;